import { render, staticRenderFns } from "./Machines.vue?vue&type=template&id=06051f4c"
import script from "./Machines.vue?vue&type=script&lang=js"
export * from "./Machines.vue?vue&type=script&lang=js"
import style0 from "./Machines.vue?vue&type=style&index=0&id=06051f4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports